  
<div class="drag-container" cdkDropList (cdkDropListDropped)="drop($event)">
  @for (item of items; track $index) {
    <div class="drag-item" cdkDrag>
        <app-button
            class="drag-handle" 
            cdkDragHandle
            [svg]="'mdi-drag'"
            [scale]="1.2"
            [injection]="{ icon: 'position: relative !important; right: 3px !important; top: 0px; margin-top:0px;'}"
            [width]="'100%'"
        >
        </app-button>

        <span
          class="item-label-box"
          [class.truncate-label]="!showFullText"
          [attr.title]="!showFullText ? item.label : null"
        >
          {{ item.label }}
        </span>
        <div class="actions">
            <app-button
                [svg]="'mdi-pencil-outline-white'"
                [scale]="0.7"
                [applyChanges]="true"
                [injection]="{ icon: 'position: relative !important; right: 3px !important; top: 0px; margin-top:0px;'}"
                (click)="editItem(item)"
                [width]="'100%'"
            ></app-button>
            <app-button
                [svg]="'mdi-delete-forever-outline-danger'"
                [scale]="0.7"
                [injection]="{ icon: 'position: relative !important; right: 3px !important; top: 0px; margin-top:0px;'}"
                (click)="deleteItem(item)"
                [width]="'100%'"
            ></app-button>
      </div>
    </div>
  }@empty {
    <div class="drag-item empty ">
      <!-- TODO: Traduccion -->
      <span class="no-data-text"> {{ notFoundText }} </span> 
    </div>
  }
</div>